<template>
    <div class="flex items-center">
        <h6>{{title}}</h6>
        <div class="ml2 bodyCopy">{{value}}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        }
    }
};
</script>
